import { render, staticRenderFns } from "./chatroom.vue?vue&type=template&id=132a45e2&scoped=true"
import script from "./chatroom.vue?vue&type=script&lang=js"
export * from "./chatroom.vue?vue&type=script&lang=js"
import style0 from "./chatroom.vue?vue&type=style&index=0&id=132a45e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a45e2",
  null
  
)

export default component.exports